import React from 'react'
import '../../views/container/cms/content.scss'
const ArrowDropDown = () => {
  return (
    <svg
      id="arrow_drop_down_black_24dp"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <defs></defs>
      <path id="Path_26" data-name="Path 26" className="cls-1" fill="none" d="M0,0H24V24H0Z" />
      <path id="Path_27" data-name="Path 27" className="cls-2" fill="#707070" d="M7,10l5,5,5-5Z" />
    </svg>
  )
}

export default ArrowDropDown
